import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/our-doctor',
      name: 'our-doctor',
      component: () => import('./views/OurDoctor.vue')
    },
    {
      path: '/contact-us',
      name: 'contact-us',
      component: () => import('./views/ContactUs.vue')
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('./views/News.vue')
    },
    {
      path: '/news/edit',
      name: 'news-edit',
      component: () => import('./views/NewsEdit.vue')
    },
    {
      path: '/news/:id',
      name: 'news-detail',
      component: () => import('./views/NewsDetail.vue')
    },
    {
      path: '/services',
      name: 'services',
      component: () => import('./views/Services.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue')
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
